import * as Yup from "yup";

export const loginSchema = Yup.object({
  UserName: Yup.string().required("Enter your username."),
  Password: Yup.string().required("Enter your password."),
});
